import React from 'react';

import lightFilter from './ImageAssets/Light-filter-blur.png';
import sheerFilter from './ImageAssets/sheer-filter-blur.png';

export const BuilderWindowCurtainTransparency = (lining: any) => {
  let liningUrl = lining.lining === 'In-between/Dim Out' ? lightFilter : sheerFilter;
  const windowStyles = {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${liningUrl})`,
    backgroundPosition: '50% 100%',
    zIndex: 5,
  };
  return <div style={windowStyles} className="stacked-image"></div>;
};
